export default {
    lang: {
        name: 'Username'
    }
}